<template>
  <div class="data-dictionary">
    <Breadcrumb pageName="数据字典"></Breadcrumb>
    <div class="content">
      <div class="left-content">
        <div class="subtitle">数据字典</div>
        <div class="dic-list">
          <div 
            :class="['dic-item',currentName===item.name?'active':'']" 
            v-for="item in dicList" 
            :key="item.name"
            @click="changeActive(item)">
            <span :class="['iconfont', 'icon-'+item.icon]"></span>
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
      <div class="right-content">
        <component :is="currentComponent"></component>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/page/Breadcrumb.vue'
import room from './room.vue'
import deviceType from './deviceType.vue'
import deviceFunction from './deviceFunction.vue'
import sprayRoom from './sprayRoom.vue'

export default {
  components: {
    Breadcrumb,
    room,
    deviceType,
    deviceFunction,
    sprayRoom
  },
  data () {
    return {
      currentName: '房间',
      currentComponent: 'room',
      dicList: [{
        name: '房间',
        value: 'room',
        icon: 'fangjian'
      }, {
        name: '设备类型',
        value: 'deviceType',
        icon: 'shebeileixing'
      }, {
        name: '设备功能',
        value: 'deviceFunction',
        icon: 'shebeigongneng'
      }, {
        name: '安防区设施',
        value: 'sprayRoom',
        icon: 'penqishisheshi'
      }]
    }
  },
  methods: {
    changeActive (val) {
      this.currentName = val.name
      this.currentComponent = val.value
    }
  }
}
</script>
<style lang="scss" scoped>
.data-dictionary {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .content{
    // flex-grow: 1;
    height: calc(100% - 40px);
    display: flex;
    // padding: 20px;
    .left-content {
      width: 308px;
      height: calc(100% - 40px);
      margin: 20px 0 20px 20px;
      background: #fff;
      font-weight: 500;
      .subtitle {
        padding: 20px;
        margin-bottom: 23px;
        font-size: 16px;
        color: #32353B;
        border-bottom: 1px solid #EDEEF2;
      }
      .dic-list {
        .dic-item {
          padding: 17px 30px;
          cursor: pointer;
        }
        .active{
          color: #00af84;
          background: #ebf9f5;
        }
        .iconfont {
          margin-right: 13px;
        }
      }
    }
    .right-content {
      // flex-grow: 1;
      width: calc(100% - 308px);
      height: 100%;
      // padding: 20px;
      background: #fff;
    }
  }
}
</style>